import { getSystemTemplates } from 'modules/Rations/redux/modules/ration/selectors';

export default getSystemTemplates;
